import { render, staticRenderFns } from "./switchCommand.vue?vue&type=template&id=7254ca58&scoped=true&"
import script from "./switchCommand.vue?vue&type=script&lang=js&"
export * from "./switchCommand.vue?vue&type=script&lang=js&"
import style0 from "./switchCommand.vue?vue&type=style&index=0&id=7254ca58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7254ca58",
  null
  
)

export default component.exports